<!--
 * @Author: zcc zcc-2578840576 2578840576@qq.com
 * @Date: 2026-03-13 14:17:59
 * @LastEditors: zcc zcc-2578840576 2578840576@qq.com
 * @LastEditTime: 2026-03-30 15:26:59
 * @FilePath: \hzs-nutra-wecom-shop\src\views\transformCustomer\selectManager.vue
 * @Description: 客户转移 - 选负责人
-->

<template>
  <div class="page-container">
    <div class="mainContent">
      <div class="searchBox flex align-center justify-sb">
        <van-icon name="search" color="#B3B3B3" size="24" />

        <input
          type="text"
          v-model="state.name"
          class="flex-1"
          placeholder="请输入客户名称或手机号搜索"
          @update:model-value="handleQueryName($event)"
        />
      </div>

      <!-- <van-pull-refresh
        v-if="state.listData.length"
        v-model="state.isRefresh"
        @refresh="onRefresh"
      >
        <van-list
          v-model:loading="state.listLoading"
          :finished="state.finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            v-for="item in state.listData"
            :key="item.shop_clerk_uuid"
            class="customerItem rel"
            :class="state.selectedId == item.shop_clerk_uuid ? 'active' : ''"
            @click="handleSelectCustomer(item)"
          >
            <div class="up flex align-center">
              <img :src="item.img || EmptyHeadImg" class="img" alt="" />

              <div class="msg">
                <div class="name">{{ item.shop_clerk_name }}</div>
                <div
                  class="gOrA"
                  :class="item.shop_clerk_status != 1 ? 'danger' : ''"
                >
                  {{ item.shop_clerk_status == 1 ? "在职" : "离职" }}
                </div>
              </div>
            </div>

            <div class="down">
              <div class="phone">手机号码：{{ item.shop_clerk_phone }}</div>
            </div>

            <van-checkbox
              v-model="item.isSelected"
              checked-color="#DCBB89"
              class="abs selectedImg"
              :disabled="item.shop_clerk_uuid === currentUserId"
            >
            </van-checkbox>
          </div>
        </van-list>
      </van-pull-refresh>
      <div v-else class="emptyBox flex align-center justify-sc">
        <van-empty
          :image="emptyCustomerImg"
          image-size="150"
          description="没有该客户？去创建新客户"
        />
      </div> -->

      <div class="pageList">
        <PullAndPush_list
          v-if="isDataReady"
          ref="listRef"
          :request="MyTeamApi._myTeamMemberAll2"
          :otherParams="otherParams"
          @loaded="onLoaded"
        >
          <template #default="{ list }">
            <div
              v-for="item in list"
              :key="item.shop_clerk_uuid"
              class="customerItem rel"
              :class="state.selectedId == item.shop_clerk_uuid ? 'active' : ''"
              @click="handleSelectCustomer(item)"
            >
              <div class="up flex align-center">
                <img :src="item.img || EmptyHeadImg" class="img" alt="" />

                <div class="msg">
                  <div class="name">{{ item.shop_clerk_name }}</div>
                  <div
                    class="gOrA"
                    :class="item.shop_clerk_status != 1 ? 'danger' : ''"
                  >
                    {{ item.shop_clerk_status == 1 ? "在职" : "离职" }}
                  </div>
                </div>
              </div>

              <div class="down">
                <div class="phone">手机号码：{{ item.shop_clerk_phone }}</div>
              </div>

              <van-checkbox
                v-model="item.isSelected"
                checked-color="#DCBB89"
                class="abs selectedImg"
                :disabled="item.shop_clerk_uuid === currentUserId"
              >
              </van-checkbox>
            </div>
          </template>
        </PullAndPush_list>
      </div>
    </div>

    <div class="bottom_button_box">
      <van-button
        round
        block
        plain
        type="primary"
        color="#DCBB89"
        class="save-btn"
        @click="router.go(-1)"
      >
        取 消
      </van-button>
      <van-button
        round
        block
        type="primary"
        color="#DCBB89"
        class="save-btn"
        @click="handleTakeOrder"
      >
        保 存
      </van-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  ref,
  reactive,
  computed,
  onMounted,
  onBeforeUnmount,
  nextTick,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import MyTeamApi from "@/utils/api/myTeam";
import { showFailToast } from "vant";
import emptyCustomerImg from "@/assets/img/customer/emptyCustomer.png";
import EmptyHeadImg from "@/assets/img/icons/emptyHeadImg.png";

// --------------------------------------- 变量
const router = useRouter();
const route = useRoute();
const { currentUserId, user_uuid } = route.query;
let department_uuid: string | undefined | null = undefined;
let isDataReady = ref(false);
const state = reactive({
  name: undefined,

  listData: [] as any[],

  pagination: {
    page: 1,
    lastPage: 1,
    pageSize: 10,
    lastPageSize: 1,
    total: 0,
  },

  isRefresh: false,
  finished: true,
  listLoading: false,

  selectedId: undefined,
});
const otherParams = computed(() => ({
  page: 1,
  page_size: 1000,
  department_uuid,
  name: state.name,
}));
const listRef = ref<any>(null);

// --------------------------------------- 方法、事件
onMounted(() => {
  let departmentData = JSON.parse(localStorage.getItem("departmentdata"));
  department_uuid = departmentData?.department_uuid;
  isDataReady.value = true;
  //   GroupService.getData();
});
function onLoaded(payload: { page: number; list: any[] }) {
  state.listData = payload.list;
}

const getGender = (type: number | string) =>
  ({
    1: "男",
    2: "女",
    3: "",
  })[type] || "";

// // 下拉刷新 -回调
// const onRefresh = async () => {
//   // 重置列表状态
//   state.isRefresh = true;
//
//   state.listData = [];
//
//   state.pagination.lastPage = state.pagination.page;
//   state.pagination.lastPageSize = state.pagination.pageSize;
//
//   state.pagination.page = 1;
//   state.pagination.pageSize =
//     state.pagination.lastPage * state.pagination.lastPageSize;
//
//   //   await GroupService.getData();
// //   listRef.value?.reloadCurrentPage();
//   await nextTick();
//   state.isRefresh = false;
//   state.pagination.pageSize = state.pagination.lastPageSize;
// };
//
// // 上拉加载 -回调 (由 van-list 触发)
// const onLoad = async () => {
//   if (state.listData.length < state.pagination.total) {
//     state.pagination.page += 1;
//     // await GroupService.getData();
// //     listRef.value?.reloadCurrentPage();
//   }
// };

// 选择客户
function handleSelectCustomer(item) {
  if (item.shop_clerk_uuid === currentUserId) return;

  item.isSelected = true;
  state.selectedId = item.shop_clerk_uuid;
  state.listData
    .filter((v) => v.shop_clerk_uuid !== item.shop_clerk_uuid)
    .map((v) => {
      v.isSelected = false;
    });
}
function handleTakeOrder() {
  if (!state.selectedId) {
    showFailToast("请点击选择负责人！");
    return;
  }

  let target = state.listData.find(
    (v) => v.shop_clerk_uuid === state.selectedId,
  );
  sessionStorage.setItem(
    "nextUser",
    JSON.stringify({
      nextName: target.shop_clerk_name,
      nextUserId: target.shop_clerk_uuid,
    }),
  );

  // 传参
  router.go(-1);
}

// 根据名称搜索
let timer_: any = null;
function handleQueryName(val) {
  state.name = val;

  if (timer_) clearTimeout(timer_);
  timer_ = setTimeout(async () => {
    try {
      //   GroupService.getData();
      listRef.value?.reloadCurrentPage();
    } catch (error) {
      console.error(error);
    }
  }, 1000); // 500毫秒延迟
}
// --------------------------------------- 请求
const GroupService = {
  getData: async () => {
    MyTeamApi._myTeamMemberAll2({
      page: 1,
      page_size: 1000,
      department_uuid,
      name: state.name,
    })
      .then((res) => {
        if (res?.code === 200) {
          const newData = res?.data || [];
          const total = res?.total || res?.cnt || 0;

          state.pagination.total = total;

          // 累加数据逻辑
          if (state.pagination.page === 1) {
            // 第一页直接覆盖 (刷新场景)
            state.listData = newData;
          } else {
            // 非第一页追加 (上拉场景)
            state.listData = [...state.listData, ...newData];
          }

          // 【关键判断】是否设置 finished
          if (state.listData.length >= state.pagination.total) {
            state.finished = true;
          } else {
            state.finished = false;
          }
        }
        let timer: any = setTimeout(() => {
          state.listLoading = false;

          clearTimeout(timer);
          timer = null;
        }, 500);
      })
      .catch(() => {
        state.listLoading = false;
      });
  },
};
</script>

<style lang="scss" scoped>
/* @use 'xxx.scss' as *; */
/*
    .page-container
        ---- 主体内容
        .mainContent

        ---- 底部操作栏
        .bottom_button_box
    @supports

    **** 在 @/scss/common.scss ****
*/

.searchBox {
  height: 45px;
  padding: 11px;
  margin-top: 10px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;

  input {
    flex: 1;
    width: calc(100% - 24px - 8px);
    height: 100%;
    border: none;
    outline: none;

    color: #999;
    font-weight: 400;
    font-size: 14px;
  }
  /* WebKit browsers */
  input::-webkit-input-placeholder,
  textarea::-webkit-input-placeholder {
    color: #999;
    font-weight: 400;
    font-size: 14px;
  }
  /* Mozilla Firefox 4 to 18 */
  input:-moz-placeholder,
  textarea:-moz-placeholder {
    color: #999;
    font-weight: 400;
    font-size: 14px;
  }
  /* Mozilla Firefox 19+ */
  input::-moz-placeholder,
  textarea::-moz-placeholder {
    color: #999;
    font-weight: 400;
    font-size: 14px;
  }
  /* Internet Explorer 10+ */
  input:-ms-input-placeholder,
  textarea:-ms-input-placeholder {
    color: #999;
    font-weight: 400;
    font-size: 14px;
  }
}

.emptyBox,
.pageList,
.van-pull-refresh {
  min-height: calc(100% - 110px - 45px - 10px - 10px);
  margin-top: 10px;

  .customerItem {
    padding: 6px;
    background: #ffffff;
    border-radius: 12px 12px 12px 12px;
    border: 1px solid transparent;

    &.active {
      border-color: #dcbb89;
    }

    &:not(:last-child) {
      margin-bottom: 10px;
    }

    .up {
      padding: 11px 10px;
      border-bottom: 1px solid #f2f2f2;

      .img {
        width: 42px;
        height: 42px;
        border-radius: 100%;

        margin-right: 11px;
      }

      .name {
        height: 25px;
        line-height: 25px;
        font-family:
          PingFang SC,
          PingFang SC;
        font-weight: 600;
        font-size: 18px;
        color: #333333;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
      .gOrA {
        height: 20px;
        line-height: 20px;
        font-family:
          PingFang SC,
          PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        text-align: left;
        font-style: normal;
        text-transform: none;

        &.danger {
          color: #ff7123;
        }
      }
    }
    .down {
      padding: 12px 10px 6px;

      font-family:
        PingFang SC,
        PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      text-align: left;
      font-style: normal;
      text-transform: none;

      div {
        height: 20px;
        line-height: 20px;
        &:not(:last-child) {
          margin-bottom: 10px;
        }
      }
    }
    .selectedImg {
      //   width: 16px;
      //   height: 16px;
      top: 16px;
      right: 16px;
    }
  }
}
</style>
